import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from '../components/landing/Navbar';
import Hero from '../components/landing/Hero';
import ProductDemo from '../components/landing/ProductDemo';
import Features from '../components/landing/Features';
import Testimonials from '../components/landing/Testimonials';
import FinalCTA from '../components/landing/FinalCTA';
import Footer from '../components/landing/Footer';
import KnowledgeGraphBackground from '../components/landing/KnowledgeGraphBackground';
import { getTenantSlug } from '../config/api';

const Landing: React.FC = () => {
  const [isHeroCtaVisible, setIsHeroCtaVisible] = useState(true);

  // Tenant subdomains are private portals — marketing landing only lives on the
  // bare withvidya.ai domain. Send tenant visitors straight to login.
  if (getTenantSlug() !== null) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen overflow-x-hidden text-gray-900" style={{ backgroundColor: '#fdfcfa' }}>
      {/* Background */}
      <KnowledgeGraphBackground />

      {/* Content wrapper */}
      <div className="relative z-10">
        <Navbar showGetStarted={!isHeroCtaVisible} />
        <Hero onCtaVisibilityChange={setIsHeroCtaVisible} />
        <Testimonials />
        <ProductDemo />
        <Features />
        <FinalCTA />
        <Footer />
      </div>
    </div>
  );
};

export default Landing;
